// extracted by mini-css-extract-plugin
module.exports = {"waveContainer":"PoolContainer_waveContainer__3XpMz","wave":"PoolContainer_wave__oXZDf","wave2":"PoolContainer_wave2__3Omwk","label":"PoolContainer_label__2UeKP"};